import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import OrderColumn from "../../Global/OrderColumn";
import { FaSort } from "react-icons/fa";
import EmptyData from "../../Global/EmptyData";
import useSeasonalStoreTimeingStore from "./useSeasonalStoreTimeingStore";
import AddSeasonalStore from "./AddSeasonalStore";

const SeasonalStoreTimeing = () => {
  const {
    isLoading,
    isFetching,
    storeList,
    showEditModal,
    menuFetching,
    storeState,
    paginationOptions,
    basicData,
    isDeleteing,
    handleDuplicateClick,
    setStoreState,
    handleEditColumnsClick,
    updateSeasonalStoreTimeingTableHeadData,
    handleDeleteModal,
    handleCreateClick,
    handleEditAction,
    handleClearClick,
    handlePagination,
    handlePageSize,
    handleSearch,
    handleDelete,
    handleSort,
    refetch,
    getRow,
  } = useSeasonalStoreTimeingStore();

  return (
    <div>
      <HeadingGroup
        title={"Seasonal Store Timing"}
        className={`pro-mb-4`}
        buttonTitle={storeList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      ></HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={storeState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: storeState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {storeList?.result?.length === 0 ? (
          <EmptyData />
        ) : menuFetching ? (
          <div className="app-loading fill"></div>
        ) : (
          <Table
            multiSelect={false}
            data={storeList?.result || []}
            uniqueID={"_id"}
            fields={storeList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            assignText={"Duplicate"}
            assignIcon={
              <span className="material-symbols-outlined">content_copy</span>
            }
            handleAssign={handleDuplicateClick}
            handleSort={handleSort}
            getRow={getRow}
            clear={storeState?.clearSelection}
            loading={isFetching}
            perpage={storeState?.currentPageSize}
            assignable={storeList?.create_permission}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={storeList?.delete_permission}
            editable={storeList?.edit_permission}
            showCheckBox={
              storeList?.delete_permission || storeList?.edit_permission
            }
          />
        )}

        {storeList?.total_count > 0 && (
          <Pagination
            currentPage={storeState?.currentPage}
            totalPageCount={Math.ceil(
              storeList?.total_count / storeState.currentPageSize,
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === storeState?.currentPageSize,
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={storeState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected Store Timing ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
              isLoading={isDeleteing}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={storeList?.fields || []}
              moduleId={storeList?.module_id}
              updateData={updateSeasonalStoreTimeingTableHeadData}
            />
          </div>
        </ModalLayout>

        <OffCanvasLayout
          show={storeState?.showCreateModal}
          handleClose={handleCreateClick}
          title={
            storeState?.isEdit
              ? "Update Seasonal Store Timing"
              : storeState?.isDuplicate
                ? "Duplicate Seasonal Store Timing"
                : "Create Seasonal Store Timing"
          }
          backdrop={"static"}
        >
          <AddSeasonalStore
            refetch={refetch}
            handleCreateClick={handleCreateClick}
            isStickyFooter
            storeState={storeState}
            setStoreState={setStoreState}
            basicData={basicData}
          />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default SeasonalStoreTimeing;
